import PropTypes from 'prop-types'
import React from 'react'
import Can from '@shared/components/Can'

import { Container, Error } from './styles'
import { FiAlertOctagon, FiEye, FiPaperclip } from 'react-icons/fi'
import { toBase64 } from '@shared/utils/file'
import { useField } from '@unform/core'

const File = ({ label, name, accept, emmitFile, onChange, containerStyle, defaultPreview, permission, ...props }) => {
  const inputRef = React.useRef(null)
  const { fieldName, registerField, error } = useField(name)

  const [previewURL, setPreviewURL] = React.useState(defaultPreview)

  const CanUpload = permission ? Can : ({ children }) => children

  React.useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'files[0]',
      getValue (input) {
        return emmitFile
          ? input.dataset.encodedFile
          : { name: input.dataset.fileName, file: input.dataset.encodedFile }
      },
      clearValue (input) {
        input.value = ''
        input.dataset.fileName = ''
        input.dataset.encodedFile = ''
        setPreviewURL(null)
      },
      setValue (_, value) {
        setPreviewURL(value)
      }
    })
  }, [fieldName, emmitFile, registerField])

  const handleChange = React.useCallback(
    async (event) => {
      if (!event.target.files.length) {
        onChange(event)
        return
      }

      const [file] = event.target.files

      setPreviewURL(URL.createObjectURL(file))

      event.target.dataset.fileName = file.name

      event.target.dataset.encodedFile = await toBase64(file)

      onChange(event)
    },
    [onChange]
  )

  return (
    <Container style={containerStyle}>
      <CanUpload perform={permission}>
        <span className="file__button">
          {label}
          <FiPaperclip className="icon--right" size={20} />
        </span>
      </CanUpload>

      {previewURL && (
        <a
          href={previewURL}
          target="_blank"
          className="file__show"
          rel="noreferrer">
          {inputRef.current?.dataset.fileName || 'Abrir'}
          <FiEye className="icon--right" size={20} />
        </a>
      )}

      <input
        ref={inputRef}
        className="file__input"
        type="file"
        accept={accept}
        onChange={handleChange}
        data-encoded-file=""
        {...props}
      />

      {error && (
        <Error title={error}>
          <FiAlertOctagon color="#c53030" size={20} />
        </Error>
      )}
    </Container>
  )
}

File.defaultProps = {
  emmitFile: true,
  onChange: () => {},
  accept: 'image/*,.pdf'
}

File.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  permission: PropTypes.string,
  defaultPreview: PropTypes.string,
  accept: PropTypes.string,
  containerStyle: PropTypes.object,
  emmitFile: PropTypes.bool,
  onChange: PropTypes.func
}

export default File
